export const WHITE = 'rgb(255, 255, 255, 1)';
export const BLACK = 'rgb(0, 0, 0, 1)';
export const LIGHTER_BLACK = 'rgb(17, 17, 17, 1)';
